<script lang="ts">
  import DieElement from './die.svelte';
  import { send, receive } from '../../animation';
  import Draggable from '../components/draggable.svelte';
  import { peekedDie } from '../../store';
  import { onMount } from 'svelte';

  let { clickEvent = (die: any) => {}, dice = [], clazz = '' } = $props();

  let element: HTMLElement;
  let slots = 16;
  let positions: Array<Array<number>> = $state([]);
  let isHorizontal: boolean = $state(false);

  function resize() {
    positions.length = 0;
    let positionsTemp: Array<Array<number>> = [];
    let dieSize: number = 80;
    let dieGap: number = 10;

    if (element) {
      dieSize = Number(getComputedStyle(element).getPropertyValue('--dice-size').replace('px', ''));
      dieGap = Number(getComputedStyle(element).getPropertyValue('--dice-gap').replace('px', ''));
      isHorizontal = element.offsetWidth > element.offsetHeight;
    }

    let containerWidth = element ? element.offsetWidth : 0;
    let containerHeight = element ? element.offsetHeight : 0;
    const maxSlots = 16;

    if (isHorizontal) {
      for (let i = 0; i < maxSlots; i++) {
        const col = Math.floor(i / 2);
        const row = i % 2;
        const rowOffset = (containerHeight - (2 * dieSize + dieGap)) / 2;
        const x = col * (dieSize + dieGap) + dieGap;
        const y = row * (dieSize + dieGap) + rowOffset;

        positionsTemp.push([x, y]);
      }
    } else {
      for (let i = 0; i < maxSlots; i++) {
        const row = Math.floor(i / 2);
        const col = i % 2;
        const colOffset = (containerWidth - (2 * dieSize + dieGap)) / 2;
        const x = col * (dieSize + dieGap) + colOffset;
        const y = row * (dieSize + dieGap) + dieGap;

        positionsTemp.push([x, y]);
      }
    }
    positions = positionsTemp;
  }

  onMount(() => {
    window.addEventListener('resize', resize);
    resize();

    return () => {
      window.removeEventListener('resize', resize);
    };
  });
</script>

<div class="container" bind:this={element}>
  <div class="dice-tray {clazz} {isHorizontal ? 'horizontal' : ''}">
    {#if positions.length}
      {#each dice as die, index (die.id)}
        <Draggable
          data={die}
          onClick={() => {
            clickEvent(die);
          }}
          onHold={() => {
            peekedDie.set(die);
          }}
          onHoldEnd={() => {
            peekedDie.set(null);
          }}
          left={positions[index][0]}
          top={positions[index][1]}
          freeMovement={true}
        >
          <div class="die-container" in:receive={{ key: die.id }} out:send={{ key: die.id }}>
            <DieElement {die} die3D={false} hover={true} redraw={dice} />
          </div>
        </Draggable>
      {/each}
    {/if}
  </div>
</div>

<style>
  .container {
    position: relative;
  }
</style>
